import { Component, Input, OnInit } from '@angular/core';
import { ICombinedReplaceIdStatistic } from 'src/app/shared/interfaces/combined-replace-id-statistic.interface';

@Component({
    standalone: false,
    selector: 'tr[app-replace-land-use-ids-row]',
    templateUrl: './replace-land-use-ids-row.component.html',
    styleUrls: ['./replace-land-use-ids-row.component.scss']
})
export class ReplaceLandUseIdsRowComponent implements OnInit {
    @Input()
    combinedReplaceIdStatistic: ICombinedReplaceIdStatistic;

    @Input()
    index: number;

    constructor() {}

    ngOnInit(): void {}
}
